<p-confirmDialog key="reportinboxjob" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="reportinboxjobconfirm1" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="reportinboxjobconfirm2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Job</button>
		<button
			[disabled]="IsLoading() == true || SelectedJob == undefined || SelectedJob?.CanEdit == false"
			class="btn btn-primary"
			style="margin-left: 5px"
			(click)="onEdit()"
		>
			Edit Job
		</button>
		<button [disabled]="IsLoading() == true || SelectedJob == undefined" class="btn btn-success" style="margin-left: 5px" (click)="onRunJob()">
			Run Job
		</button>
		<button
			[disabled]="IsLoading() == true || SelectedJob == undefined || SelectedJob?.CanEdit == false"
			class="btn btn-warning"
			style="margin-left: 5px"
			(click)="onToggle()"
		>
			{{ ToggleText }}
		</button>
		<button
			[disabled]="IsLoading() == true || SelectedJob == undefined || SelectedJob?.CanEdit == false"
			class="btn btn-danger"
			style="margin-left: 5px"
			(click)="onDelete()"
		>
			Delete Job
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstJob"
		[loading]="IsLoading()"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedJob"
		dataKey="JobID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--JobDesc-->
				<th>
					<p-columnFilter type="text" field="JobDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ReportScriptDesc-->
				<th>
					<p-columnFilter type="text" field="ReportScriptDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--c_UserName-->
				<th>
					<p-columnFilter type="text" field="c_UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ScheduleDesc-->
				<th>
					<p-columnFilter type="text" field="ScheduleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--RecipientsDesc-->
				<th>
					<p-columnFilter type="text" field="RecipientsDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--c_date-->
				<th>
					<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="JobDesc">Job<p-sortIcon field="JobDesc"></p-sortIcon></th>
				<th pSortableColumn="ReportScriptDesc">Report<p-sortIcon field="ReportScriptDesc"></p-sortIcon></th>
				<th pSortableColumn="c_UserName">Created By<p-sortIcon field="c_UserName"></p-sortIcon></th>
				<th pSortableColumn="ScheduleDesc">Schedule<p-sortIcon field="ScheduleDesc"></p-sortIcon></th>
				<th pSortableColumn="RecipientsDesc">Send To<p-sortIcon field="RecipientsDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="c_date">Last Updated<p-sortIcon field="c_date"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Job>
			<!-- <tr [pSelectableRow]="Job" (dblclick)="onRowDblClick(Job)"> -->
			<tr [pSelectableRow]="Job">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Job.JobDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Job.ReportScriptDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Job.CanEdit == true ? 'Black' : 'Red'">
					{{ Job.c_UserName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Job.ScheduleDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Job.RecipientsDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Job.Active == true ? 'Black' : 'Red'">
					{{ Job.ActiveDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Job.c_dateDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
